// Copyright (c) 2020 WiseTime. All rights reserved.

// Only print debug message in development environment
export const debug = (msg: string): void => {
  if (process.env.NODE_ENV === "development") {
    const timestamp = new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString()
    console.log(timestamp + " - " + msg)
  }
}
